import { render, staticRenderFns } from "./DetailPenerbitanNonberusaha.vue?vue&type=template&id=09d8feda&"
import script from "./DetailPenerbitanNonberusaha.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanNonberusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports